import { Box, Container, ContainerProps } from "@mui/material";
import React from "react";
import { Bg } from "src/assets";
import { createStyles } from "src/main/utils";

interface ContentProps extends React.PropsWithChildren, ContainerProps {}

const Content: React.FC<ContentProps> = (props) => {
  const { children, ...containerProps } = props;

  return (
    <Box sx={styles.root}>
      <Container
        {...containerProps}
        sx={styles.container}
      >
        {children}
      </Container>
    </Box>
  );
};

const styles = createStyles({
  root: {
    minHeight: "100vh",
    maxWidth: "560px",
    margin: "0 auto",
  },
  container: {
    height: "100%",
    minHeight: "100vh",
    backgroundImage: `url(${Bg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    backgroundColor: "#141414",
  },
});

export default Content;
